import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { Content } from 'core/layouts';
import { PatientMissingDocsTemplateEdit } from "application/patient-missing-docs/components";
import { BasicCheckbox } from 'core/components';
import { uuid } from "core/utils";
function PatientMissingDocsEditTemplate({ patientMissingDocsEditViewStore }) {
	const {
		loaderStore,
		contentLoading,
		item,
		changePastDosVisiblity,
		isPastDosVisible,
		facilityOrderTemplateStore,
		pastFacilityOrderTemplateStores,
		showOnlyCheckedPastTemplates,
		setShowOnlyCheckedPastTemplates
	} = patientMissingDocsEditViewStore;

	const includeInDocReqEmail = pastFacilityOrderTemplateStores && pastFacilityOrderTemplateStores.length > 0 && pastFacilityOrderTemplateStores.some(x => x.item && x.item.includeInDocReqEmail);
	const storesToRender = pastFacilityOrderTemplateStores && pastFacilityOrderTemplateStores.length
		? includeInDocReqEmail
			? pastFacilityOrderTemplateStores.filter(x => !showOnlyCheckedPastTemplates || (x.item && x.item.includeInDocReqEmail))
			: pastFacilityOrderTemplateStores
		: [];

	return (
		<Content loading={contentLoading || loaderStore.loading} >
			{item &&
				<React.Fragment>
					<div className={`card--patient`}>
						<div className="card--patient__header">
							<label className="u-mar--right--tny"> {item.subCategory.name} </label>
							<label> {item.templateId}</label>
						</div>
						<div className="card--patient__body">
						<PatientMissingDocsTemplateEdit
							key={item.id}
							patientMissingDocsTemplateEditViewStore={facilityOrderTemplateStore}
							showAdditionalData={true}
						/>
						</div>
						{pastFacilityOrderTemplateStores && pastFacilityOrderTemplateStores.length > 0 &&
							<div className='u-mar--left--med u-mar--right--med'>
								<div className='u-mar--top--med u-mar--bottom--med u-flex--default' onClick={() => changePastDosVisiblity()}>
									<div className='u-flex--default u-flex--space-between'>
										<i className={"u-icon u-icon--xsml " + (isPastDosVisible ? "u-icon--arrow-up" : "u-icon--arrow-down") + " u-mar--right--sml"} />
										<label className="u-mar--right--sml">Past DOS</label>
									</div>

									{includeInDocReqEmail &&
										<div className="checkbox--special">
											<BasicCheckbox id={uuid()} checked={showOnlyCheckedPastTemplates} onChange={() => setShowOnlyCheckedPastTemplates()} />
											<label className="checkbox--special__label">Show only checked past templates</label>
										</div>
									}
								</div>
								<div>
								{
									isPastDosVisible &&
									storesToRender.map(store => {
										return (
											<div key={store.item.id} className={`card--patient is-child`}>
												<div className='card--patient__body'>
												<PatientMissingDocsTemplateEdit
													key={store.item.id}
													patientMissingDocsTemplateEditViewStore={store}
													showAdditionalData={false}
												/>
												</div>
											</div>
										);
									})
								}
								</div>
							</div>
						}
					</div>
				</React.Fragment>
			}
		</Content>
	)
}

PatientMissingDocsEditTemplate.propTypes = {
	patientMissingDocsEditViewStore: PropTypes.object.isRequired,
};

export default defaultTemplate(PatientMissingDocsEditTemplate);